import {
  EActivityType,
  EProblemReportDateFilter,
  EProblemReportStatus,
  EProductTourTargets
} from '@constants';
import { Input } from 'antd';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';

import { DownloadProblemReports } from '../DownloadProblemReports';

import { ActionsWrapper, FiltersWrapper, TourWrapper, Wrapper } from './FiltersHandler.styles';

import {
  ActivityTypeFilter,
  CourseSearchFilter,
  ProblemReportDateFilter,
  ReportStatusFilter,
  TagSelector
} from '@/components/Form';
import { useAllCoursesForSelectors, useProblemReportsList, useProfile } from '@/store';

type Props = {
  tabStatus?: EProblemReportStatus[];
};

type ReportStatusValue = EProblemReportStatus.NOT_REVIEWED | EProblemReportStatus.IN_REVIEW;

export const FiltersHandler: React.FC<Props> = ({ tabStatus }) => {
  const { t } = useTranslation(['DefaultTranslations', 'ProblemReportsTranslations']);
  const {
    roleCheck: { isManager }
  } = useProfile();

  const { filter, updateFilter, setSearch } = useProblemReportsList(tabStatus);
  const { courses } = useAllCoursesForSelectors();

  const isAllTab = !tabStatus || tabStatus.length === 0;

  const handleProblemReportSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value === '') {
      setSearch(undefined);
      return;
    }
    if (value.length < 3) return;
    setSearch(value);
  };

  const handleSearch = debounce(handleProblemReportSearch, 500);

  return (
    <Wrapper>
      <FiltersWrapper>
        <Input.Search placeholder={t('SEARCH')} onChange={handleSearch} allowClear />
        <TourWrapper id={EProductTourTargets.PROBLEM_REPORTS_FILTERS}>
          <ActivityTypeFilter
            value={filter?.type}
            onChange={(value: EActivityType | undefined) => updateFilter('type', value)}
          />
          {isManager && (
            <TagSelector
              value={filter?.tags}
              onChange={(value: string | string[]) => updateFilter('tags', value as string[])}
              allowClear
              mode="multiple"
            />
          )}
          <CourseSearchFilter
            mode="multiple"
            value={filter?.courseIds}
            onChange={(value: string[] | string | undefined) =>
              updateFilter('courseIds', value as string[])
            }
            courses={courses || []}
            placeholder={t('COURSES')}
          />
          <ProblemReportDateFilter
            value={filter?.date}
            dateRange={filter?.dateRange}
            onChange={(value: EProblemReportDateFilter | undefined) => updateFilter('date', value)}
            onDateRangeChange={(value: [string, string] | undefined) =>
              updateFilter('dateRange', value)
            }
          />
          <ReportStatusFilter
            value={filter?.reportStatus}
            onChange={(value: ReportStatusValue[] | undefined) =>
              updateFilter('reportStatus', value)
            }
          />
        </TourWrapper>
      </FiltersWrapper>
      <ActionsWrapper>{isAllTab && <DownloadProblemReports />}</ActionsWrapper>
    </Wrapper>
  );
};
